import React from 'react';
import styled from 'styled-components';

import {withLabels, withLogo} from '../lib/labels'

import Window from './Window';
import Header from './Header';
import UnstyledSidebar from './Sidebar';

function Screen({title, windowTitle, activeLink, actions, tabs, showTitle = true, children, labels = {}, logoSrc}) {
  windowTitle = windowTitle || title;

  return (
    <Window title={windowTitle}>
      <Sidebar activeLink={activeLink} {...labels} logoSrc={logoSrc} />
      <Content>
        <Header title={title} showTitle={showTitle} actions={actions} tabs={tabs} activeLink={activeLink} labels={labels} logoSrc={logoSrc}/>
        {children}
      </Content>
    </Window>
  );
}

const Sidebar = styled(UnstyledSidebar)`
  position: fixed;
  top: 0;
  bottom: 0;
  left: 0;

  @media (max-width: 50rem) {
    visibility:hidden;
  }
`;

const Content = styled.div`
  margin-left: 15rem;

  @media (max-width: 50rem) {
    margin-left: 0;
  }
`;

export default withLogo(withLabels(Screen));
